/* mm-schweber.js — die zwei schwebenden Fremd-Bausteine baendigen.
 *
 * 22.08.2026, Mert: "es nervt es muss bewegbar sein und ausblenden moeglich
 * sein die ki nervt und das genauso".
 * 23.08.2026, Mert: "punkte sammeln kleiner machen und beides schliessen
 * koennen — also die ki und punkte".
 *
 * Betroffen sind zwei Bausteine, die nicht aus dem Theme kommen:
 *   1. der KI-Berater von JotForm  -> .embedded-agent-container (64x64, links unten)
 *   2. "Punkte sammeln" von Smile  -> #smile-ui-lite-launcher-frame-container
 *      (198x60, rechts unten, Inhalt liegt in einem iframe)
 *
 * Beide bringen keinen Schliessen-Knopf mit. Weil ihr Inhalt in einem iframe
 * steckt, kommt kein Mausereignis von dort nach draussen - Ziehen am Baustein
 * selbst ist also nicht moeglich. Deshalb bekommt jeder eine eigene kleine
 * Leiste: links der Griff zum Verschieben, rechts das Kreuz zum Ausblenden.
 *
 * Geschlossen und verschoben wird fuer die laufende Sitzung gemerkt
 * (sessionStorage) - beim naechsten Besuch ist wieder alles am Platz.
 *
 * 01.09.2026: Die Bedienleisten bleiben innerhalb ihres jeweiligen App-Halters,
 * damit Sprach- und App-Beobachter keine fremden Geschwisterknoten verarbeiten
 * muessen. Smiles `zoom` wird an der Leiste exakt gegenskaliert: Die Knoepfe
 * bleiben sichtbar 24 px gross und duerfen dank `overflow:visible` nicht mehr
 * angeschnitten werden. Beide Apps erscheinen ohne Positions-Transition sofort
 * an ihrer sicheren Endposition. Die automatische Begruessungsblase und die
 * Pulsringe der KI bleiben aus; der Avatar selbst ist weiterhin anklickbar.
 *
 * 17.09.2026, Mert (iPhone): "punkte sammeln section fehlerhaft, abgeschnitten".
 * Smile wird nicht mehr per `zoom` verkleinert, sondern per `scale` - Safari
 * rechnet `zoom` nicht in den Inhalt eines iframes hinein und zeigte nur die
 * linke obere Ecke des Knopfs. Details bei faktor().
 */
(function () {
  'use strict';

  var ZIEL = [
    { name: 'punkte',
      wahl: '#smile-ui-lite-launcher-frame-container',
      /* 02.09.2026 nochmals kompakter: 0,52 macht aus 198x60 sichtbar etwa
         103x31. Die Beschriftung bleibt lesbar, der Dauergast nimmt aber
         deutlich weniger Platz am Bildschirmrand ein. */
      groesse: 0.52,
      /* 17.09.2026: Smiles runder Handy-Knopf (44x44) ist schon klein genug
         und bleibt in Originalgroesse - siehe faktor(). */
      kompakt: 64,
      /* Smiles Knopf liegt in einem fremden iframe und laesst sich nicht
         fernsteuern. Deshalb zieht hier nur der Rand; die Mitte bleibt
         zum Anklicken frei (siehe .mmSchDeckRand). */
      mitte: true,
      ecke: 'rechts' },
    { name: 'ki',
      wahl: '.embedded-agent-container',
      groesse: 1,
      /* 25.08.2026, Mert: "hoeher DIE ki nicht so tief". Der Avatar sass so
         weit unten, dass er am Rand klebte und auf der Produktseite in den
         Kaufbereich ragte. 70 px heben ihn frei, ohne dass er in den Text
         laeuft - er bleibt in seiner Ecke. */
      hoch: 70,
      /* 17.09.2026: JotForms Halter ist inzwischen fensterbreit - sichtbar
         und anfassbar ist nur dieser runde Avatar. Siehe kernRect(). */
      kern: '.ai-agent-chat-avatar',
      ecke: 'links' }
  ];

  var SCHLUESSEL = 'mmSchweber:';
  var SICHTBAR_MS = 20000;   /* so lange steht es da */
  var WEG_MS = 60000;        /* so lange ist es weg */

  /* 25.08.2026, Mert: "mach das so das das nicht ueberdeckt wird dieser bereich /
     bei startseite ist egal aber auf produkt seite nicht".
     Auf der Produktseite liegen genau dort Kaufknopf, Abo-Auswahl und der
     2er-Set-Upsell - also die Stellen, an denen entschieden wird. Der Punkte-
     Knopf sass darueber. Deshalb steht er auf Produktseiten hoeher und rueckt
     zusaetzlich zur Seite, sobald er einen dieser Bereiche verdecken wuerde.
     Auf der Startseite bleibt alles wie bisher. */
  var PRODUKTSEITE = /^\/products\//.test(window.location.pathname);
  var HOCH_AUF_PRODUKT = 96;   /* zusaetzliche Hoehe in px */

  /* Diese Bereiche duerfen nie verdeckt werden. */
  var HEILIG = [
    'form[action*="/cart/add"]',
    '.shopify_subscriptions_app_container',
    '.st_multi_upsells_container',
    '.st_multi_upsell_item',
    '[class*="sternify_upsell"]',
    '[id*="sternify-upsell"]',
    '[class*="upsell"]',
    'button[name="add"]',
    '.buy-buttons-block',
    'variant-picker',
    '[class*="quantity-selector"]'
  ].join(',');

  var css = [
    /* Die Leisten bleiben in ihrem App-Halter. Eine inverse Skalierung hebt
       Smiles Verkleinerung (seit 17.09.2026 `scale`) nur fuer die Bedienung
       wieder auf. */
    '.mmSchLeiste{position:absolute;display:flex;gap:3px;z-index:2147483647;',
    'box-sizing:border-box;padding:2px;border:1px solid rgba(21,16,19,.13);',
    'border-radius:999px;background:rgba(255,255,255,.10);',
    '-webkit-backdrop-filter:blur(12px) saturate(150%);',
    'backdrop-filter:blur(12px) saturate(150%);',
    'box-shadow:0 5px 18px rgba(21,16,19,.20),',
    'inset 1px 1px 1px rgba(255,255,255,.45),',
    'inset -1px -1px 1px rgba(21,16,19,.10);',
    'opacity:0;visibility:hidden;pointer-events:none;',
    'transition:opacity .16s ease,visibility 0s linear .16s}',
    '.mmSchLeiste.mmSchLeisteDa{opacity:1;visibility:visible;pointer-events:auto;',
    'transition:opacity .16s ease}',
    /* 25.08.2026 Sicherheitsnetz: Diese Halter duerfen unter keinen Umstaenden
       ueber den rechten Rand hinausragen - sonst entsteht eine waagerechte
       Bildlaufleiste und auf dem Handy verschiebt sich die ganze Seite.
       Das ist unabhaengig davon, wer sie verschiebt (wir oder die App). */
    '.mmSchHalter{max-width:100vw;overflow:visible!important;transition:none!important}',
    '#smile-ui-lite-launcher-frame-container.mmSchHalter{overflow:visible!important}',
    '#smile-ui-lite-launcher-frame-container.mmSchHalter #smile-lite-launcher-frame{',
    'border-radius:30px!important;clip-path:inset(0 round 30px)}',
    /* Die JotForm-Begruessung vergroessert den 64-px-Launcher kurz auf 256x133
       und klappt ihn danach wieder zu. Das war das sichtbare Auf-/Zuklappen. */
    '.embedded-agent-container .ai-agent-chat-avatar-tooltip,',
    '.embedded-agent-container .ai-agent-chat-avatar-pulse{display:none!important}',
    '.embedded-agent-container .ai-agent-chat-avatar{outline:3px solid #fff!important;',
    'outline-offset:1px!important;box-shadow:0 8px 22px rgba(21,16,19,.2)!important}',
    /* 04.09.2026, Mert: "kreuz felder und das andere glas/transparent machen".
       Statt der fast deckenden grauen Scheibe jetzt echtes Glas: der Grund
       bleibt sichtbar, die Kante faengt das Licht, das Symbol traegt einen
       feinen Schatten, damit es auf hellem UND dunklem Grund lesbar ist. */
    '.mmSchKnopf{box-sizing:border-box;width:24px;height:24px;min-width:24px;',
    'min-height:24px;border-radius:50%;border:1px solid rgba(255,255,255,.55);',
    'background:rgba(255,255,255,.14);color:#fff;font-size:11px;line-height:1;',
    '-webkit-backdrop-filter:blur(14px) saturate(170%);',
    'backdrop-filter:blur(14px) saturate(170%);',
    'filter:drop-shadow(0 1px 1px rgba(21,16,19,.45));',
    'padding:0;cursor:pointer;-webkit-tap-highlight-color:transparent;',
    'display:flex;align-items:center;justify-content:center;',
    'box-shadow:0 2px 6px rgba(21,16,19,.22);transition:background .16s ease,',
    'transform .16s ease}',
    '.mmSchKnopf:hover{background:rgba(255,255,255,.26);transform:translateY(-1px)}',
    '.mmSchKnopf:focus-visible{outline:2px solid rgba(229,20,42,.38);outline-offset:2px}',
    '.mmSchZu:hover{background:rgba(229,20,42,.55);border-color:rgba(255,255,255,.7)}',
    /* Die unsichtbare Ziehflaeche ueber dem ganzen Baustein. */
    '.mmSchDeck{position:absolute;inset:0;z-index:2147483646;cursor:grab;',
    'touch-action:none;background:transparent;border-radius:inherit}',
    '.mmSchDeck:active{cursor:grabbing}',
    /* Bei Smile sitzt der Knopf in einem fremden iframe - dort zieht nur der',
       Rand, die Mitte bleibt zum Anklicken frei. */
    '.mmSchDeckRand{clip-path:polygon(0 0,100% 0,100% 100%,0 100%,0 0,',
    '18% 26%,18% 74%,82% 74%,82% 26%,18% 26%)}',
    '.mmSchGriff{cursor:grab;touch-action:none}',
    '.mmSchGriff:active{cursor:grabbing}',
    '.mmSchKnopf svg{width:12px;height:12px;display:block}',
    '.mmSchGriff svg{width:13px;height:13px}',
    '@media(prefers-reduced-motion:reduce){.mmSchLeiste,.mmSchKnopf{transition:none!important}}'
  ].join('');

  var KREUZ = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" ' +
              'stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' +
              '<path d="M2.5 2.5 9.5 9.5M9.5 2.5 2.5 9.5"/></svg>';
  /* 04.09.2026, Mert: "mach symbole hand" - der Punktgriff wird zur Hand.
     Eine offene Hand ist das gelernte Zeichen fuer "anfassen und ziehen". */
  var GRIFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
              'aria-hidden="true">' +
              '<path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11"/>' +
              '<path d="M12 11V4.5a1.5 1.5 0 0 1 3 0V11"/>' +
              '<path d="M15 11V6.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-1.2a6 6 0 0 1-4.6-2.2L4 15.5' +
              'a1.5 1.5 0 0 1 2.3-1.9L9 16"/></svg>';

  function stil() {
    if (document.getElementById('mm-schweber-stil')) return;
    var s = document.createElement('style');
    s.id = 'mm-schweber-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function merke(k, wert) {
    try { window.sessionStorage.setItem(SCHLUESSEL + k, wert); } catch (e) {}
  }
  function lies(k) {
    try { return window.sessionStorage.getItem(SCHLUESSEL + k); } catch (e) { return null; }
  }

  /* Langify beobachtet den gesamten Teilbaum erneut, sobald in einem fremden
     App-Halter ein Kind ergaenzt wird. Dabei versucht die App auch fremde
     Shadow-Roots mit ihrem eigenen MutationObserver zu beobachten und wirft
     einen Fehler. Diese beiden Bedienleisten enthalten keinen uebersetzbaren
     Inhalt; deshalb markieren wir ausschliesslich ihre beiden App-Teilbaeume
     als gesperrt, bevor der eine neue Knoten eingesetzt wird. */
  function uebersetzerSperre(knoten) {
    if (!knoten || !knoten.setAttribute) return;
    knoten.setAttribute('data-ly-locked', 'true');
    var kinder = knoten.querySelectorAll ? knoten.querySelectorAll('*') : [];
    for (var i = 0; i < kinder.length; i++) {
      kinder[i].setAttribute('data-ly-locked', 'true');
    }
  }

  /* 23.08.2026 GEMESSEN: `transform: scale(.62) !important` stand inline am
     Smile-Halter, die gerechnete Angabe blieb trotzdem `matrix(1,0,0,1,0,0)`.
     Grund: Smile faehrt seinen Knopf mit einer CSS-Animation ein, und eine
     laufende oder festgehaltene Animation steht in der Rangfolge ueber jeder
     Inline-Angabe - auch ueber `!important`.
     Deshalb wird die Groesse jetzt mit `zoom` gesetzt (davon weiss die
     Animation nichts) und das Verschieben ueber die Kantenabstaende geloest
     statt ueber `translate`.
     ABGELOEST am 17.09.2026: `zoom` schnitt Smiles Knopf in Safari ab. Jetzt
     `scale` (ebenfalls unberuehrt von der Animation) - siehe faktor(). */
  function grundwerte(el, z) {
    if (el.__mmBasis) return el.__mmBasis;
    var c = getComputedStyle(el);
    el.__mmBasis = {
      unten: parseFloat(c.bottom) || 0,
      seite: parseFloat(z.ecke === 'rechts' ? c.right : c.left) || 0
    };
    return el.__mmBasis;
  }

  /* 17.09.2026, Mert (iPhone-Bildschirmfoto): "punkte sammeln section
     fehlerhaft, abgeschnitten". GEMESSEN, zwei Ursachen:

     1. Safari (auch am Mac) rechnet CSS-`zoom` NICHT in den Inhalt eines
        iframes hinein. Der Halter wurde auf 0,52 verkleinert, Smiles Knopf im
        iframe blieb in voller Groesse - zu sehen war nur seine linke obere
        Ecke. Chrome zoomt den iframe-Inhalt mit, deshalb fiel es dort nie auf.
        Dazu liefert Safari getBoundingClientRect() bei `zoom` in anderen
        Einheiten als Chrome - jede Randkorrektur rechnete dort falsch.
        Jetzt: Verkleinert wird ueber die eigenstaendige Eigenschaft `scale`,
        Ursprung rechts unten. Transformationen skalieren iframes in jedem
        Browser gleich, und Smiles Einblend-Animation (`transform: scale(.8)`
        -> `scale(1)`) beruehrt `scale` nicht. Die rechte und untere Kante des
        sichtbaren Knopfs bleiben dabei die Kanten des Halters - Kantenabstaende
        sind also wieder echte Bildschirmpixel, ohne Umrechnung.

     2. Smile zeigt am Handy seit 15.09.2026 statt der Pille (198x60) einen
        runden Knopf von 44x44 ("smile-improved-mobile-launcher"). Den noch
        einmal auf 0,52 zu schrumpfen ergab 23 px - zu klein zum Tippen und
        zu klein fuer die Bedienleiste, die deshalb gar nicht mehr erschien.
        Jetzt: Was hoechstens `kompakt` Pixel breit ist, bleibt in
        Originalgroesse. Wechselt Smile beim Drehen oder Vergroessern des
        Fensters die Form, rechnet nachziehen() den Faktor neu. */
  function faktor(z, el) {
    if (!z.groesse || z.groesse === 1) return 1;
    if (el && z.kompakt && el.offsetWidth && el.offsetWidth <= z.kompakt) return 1;
    return z.groesse;
  }

  function massstab(el, z) {
    var f = faktor(z, el);
    if (!z.groesse || z.groesse === 1) return f;
    el.style.removeProperty('zoom');
    if (f === 1) el.style.removeProperty('scale');
    else el.style.setProperty('scale', String(f), 'important');
    el.style.setProperty('transform-origin', '100% 100%', 'important');
    if (el.__mmLeiste) {
      el.__mmLeiste.style.setProperty('transform', 'scale(' + (1 / f) + ')', 'important');
    }
    return f;
  }

  /* 17.09.2026: Was sieht man wirklich? JotForms KI-Halter ist inzwischen so
     breit wie das Fenster (am Handy 393 statt 64 px), sichtbar ist nur der
     runde Avatar links darin. Alle Rechnungen liefen ueber die ganze Breite:
       - imBildHalten pendelte zwischen links +12 und -12 px, weil 393 px nie
         gleichzeitig 12 px Abstand zu beiden Raendern halten koennen. Blieb es
         bei -12 stehen, war der Avatar links angeschnitten;
       - die unsichtbare Ziehflaeche lag als fensterbreiter Streifen ueber der
         Seite, fing dort jedes Tippen ab und blockierte das Scrollen
         (`touch-action:none`);
       - waagerecht verschieben ging nicht mehr - kein Platz fuer 393 px.
     Jetzt zaehlt bei Bausteinen mit `kern` nur dessen Flaeche. Ist der Kern
     nicht zu finden, gilt wie bisher der ganze Halter. */
  function kernRect(el, z) {
    if (!z.kern) return null;
    var k = el.querySelector(z.kern);
    if (!k) return null;
    var kr = k.getBoundingClientRect();
    return (kr.width && kr.height) ? kr : null;
  }

  /* Sichtbare Flaeche (b, h, s) und ihr Versatz (vx, vy) gegenueber der linken
     oberen Ecke des Halters vor `scale`. Ohne Kern reine Layout-Rechnung - so
     stoert Smiles Einblend-Animation die Messung nicht. */
  function vermessen(el, z) {
    var kr = kernRect(el, z);
    var r = el.getBoundingClientRect();
    if (kr) {
      return { b: kr.width, h: kr.height, vx: kr.left - r.left, vy: kr.top - r.top, s: kr };
    }
    var f = faktor(z, el);
    var kb = el.offsetWidth || 64;
    var kh = el.offsetHeight || 64;
    return { b: kb * f, h: kh * f, vx: kb * (1 - f), vy: kh * (1 - f), s: r };
  }

  /* Die Ziehflaeche liegt bei Bausteinen mit Kern nur ueber dem Kern. */
  function deckStellen(el, z) {
    var deck = el.__mmDeck;
    if (!z.kern || !deck || !deck.isConnected) return;
    var kr = kernRect(el, z);
    if (!kr) { deck.style.display = 'none'; return; }
    var r = el.getBoundingClientRect();
    deck.style.display = '';
    deck.style.left = Math.round(kr.left - r.left) + 'px';
    deck.style.top = Math.round(kr.top - r.top) + 'px';
    deck.style.right = 'auto';
    deck.style.bottom = 'auto';
    deck.style.width = Math.round(kr.width) + 'px';
    deck.style.height = Math.round(kr.height) + 'px';
    deck.style.borderRadius = '50%';
  }

  /* In der Theme-Vorschau liegt unten eine feste Shopify-Leiste. Die Apps
     kennen sie nicht. Auf der echten Seite ist der Wert einfach 12 px. */
  function freierBoden() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar) return 12;
    var r = bar.getBoundingClientRect();
    var c = getComputedStyle(bar);
    if (!r.height || c.display === 'none' || c.visibility === 'hidden') return 12;
    if (r.top >= window.innerHeight || r.bottom <= 0) return 12;
    return Math.max(12, window.innerHeight - r.top + 12);
  }

  /* --- Frei gezogene Position ------------------------------------------------
     04.09.2026, Mert: "man kann nur hoch und runter bewegen, man soll es aber
     komplett frei bewegen koennen egal wohin, und es soll nicht ruckeln, buggen,
     gerade buggt es wenn man scrollt".

     ZWEI FEHLER, beide hier behoben:

     1. NUR HOCH/RUNTER. Die Position wurde aus den Kantenabstaenden (right/bottom)
        plus Grundwerten zurueckgerechnet. Jede Nachkorrektur - imBildHalten beim
        Rand, freiHalten beim Ausweichen vor den Upsell-Karten - hat den seitlichen
        Wert wieder ueberschrieben. Waagerecht kam man deshalb nicht weit.
        Jetzt gilt: Sobald der Nutzer selbst verschiebt, zaehlen nur noch left/top
        in echten Fensterkoordinaten (mmFrei=1). Keine Rueckrechnung mehr.

     2. RUCKELN BEIM SCROLLEN. An jedem Scroll-Ereignis hingen Messungen des halben
        Seiteninhalts (ueberlappt), dazu imBildHalten und leisteStellen - also
        Lesen und Schreiben am Layout im Wechsel, viele Male pro Sekunde.
        Jetzt: Wer selbst verschoben hat, wird beim Scrollen gar nicht mehr
        angefasst. Die Bedienleiste sitzt ohnehin IM Halter und wandert von allein
        mit; ihr Scroll-Listener war ueberfluessig und ist entfernt. */
  function freiStellen(el, z, px, py, masse) {
    /* Die Masse werden beim Ziehstart EINMAL gemessen und durchgereicht. Sie bei
       jeder Bewegung neu zu lesen, zwingt den Browser zum Neuberechnen des
       Layouts - genau daran hat es gehakt.
       17.09.2026: px/py meinen die SICHTBARE Flaeche (Smiles verkleinerter
       Knopf, der Avatar der KI).
       masse = [sichtbare Breite, sichtbare Hoehe, Versatz x, Versatz y] */
    if (!masse) {
      var m = vermessen(el, z);
      masse = [m.b, m.h, m.vx, m.vy];
    }
    var b = masse[0] || 64;
    var h = masse[1] || 64;
    var rand = 6;
    px = Math.max(rand, Math.min(window.innerWidth - b - rand, px));
    py = Math.max(rand, Math.min(window.innerHeight - h - freierBoden() - rand, py));
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('left', (px - masse[2]) + 'px', 'important');
    el.style.setProperty('top', (py - masse[3]) + 'px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('transition', 'none', 'important');
    el.dataset.mmFrei = '1';
    return [px, py];
  }

  function imBildHalten(el, z) {
    if (el.dataset.mmWeg === '1') return;
    if (el.dataset.mmFrei === '1') return;   /* der Nutzer hat entschieden */
    /* 17.09.2026: nur die sichtbare Flaeche muss ins Bild (kernRect). */
    var r = kernRect(el, z) || el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var rand = 12;
    var eigenschaft = z.ecke === 'rechts' ? 'right' : 'left';
    var seite = parseFloat(el.style.getPropertyValue(eigenschaft));
    if (isNaN(seite)) seite = 0;

    /* Seit 17.09.2026 ohne Umrechnung: Mit `scale` (Ursprung rechts unten)
       verschiebt ein Pixel Kantenabstand den sichtbaren Knopf um genau ein
       Pixel - in jedem Browser. */
    if (r.left < rand) {
      seite += (z.ecke === 'rechts' ? -1 : 1) * (rand - r.left);
    } else if (r.right > window.innerWidth - rand) {
      seite += (z.ecke === 'rechts' ? 1 : -1) *
               (r.right - (window.innerWidth - rand));
    }
    el.style.setProperty(eigenschaft, seite + 'px', 'important');

    r = kernRect(el, z) || el.getBoundingClientRect();
    var unten = parseFloat(el.style.getPropertyValue('bottom'));
    if (isNaN(unten)) unten = 0;
    var maxUnten = window.innerHeight - freierBoden();
    if (r.bottom > maxUnten) unten += (r.bottom - maxUnten);
    if (r.top < rand) unten -= (rand - r.top);
    el.style.setProperty('bottom', unten + 'px', 'important');
    el.dataset.mmUnten = unten -
      (el.dataset.mmAusweich === '1' ? AUSWEICH_PX : 0);
  }

  /* Die Bedienleiste wird relativ zum App-Halter gesetzt. Beim KI-Halter zaehlen
     nur die unteren 64 px, weil dort der Avatar sitzt; eine groessere Chatflaeche
     veraendert ihre Position dadurch nicht. Bei Smile hebt `scale(1 / f)`
     die Verkleinerung des Elternhalters auf, ohne einen Knoten aus dem App-
     Teilbaum herauszunehmen. */
  function leisteStellen(el, z) {
    var leiste = el.__mmLeiste;
    if (!leiste || !leiste.isConnected) return;
    deckStellen(el, z);
    var r = el.getBoundingClientRect();
    var kr = kernRect(el, z);
    var s = kr || r;
    /* 17.09.2026: Schwelle von 50x30 auf 36x24 - Smiles runder Handy-Knopf
       misst 44x44 und muss die Leiste ebenfalls bekommen. Gemessen wird die
       sichtbare Flaeche, nicht der (bei der KI fensterbreite) Halter. */
    var bereit = el.dataset.mmWeg !== '1' && s.width >= 36 && s.height >= 24 &&
      s.bottom > 0 && s.top < window.innerHeight &&
      getComputedStyle(el).display !== 'none';
    if (!bereit) {
      leiste.classList.remove('mmSchLeisteDa');
      return;
    }

    var f = faktor(z, el);
    var l = leiste.getBoundingClientRect();
    var breite = l.width || 56;
    var hoehe = l.height || 30;
    var elBreite = el.offsetWidth || (r.width / f);
    var elHoehe = el.offsetHeight || (r.height / f);
    var links;
    var oben;
    if (kr) {
      /* Mit Kern (KI, f = 1): mittig und 6 px ueber dem Avatar, gerechnet von
         der linken oberen Ecke des Halters aus. */
      links = kr.left - r.left + (kr.width - breite) / 2;
      oben = kr.top - r.top - hoehe - 6;
    } else if (z.ecke === 'links') {
      links = (Math.min(64 / f, elBreite) - breite / f) / 2;
      oben = elHoehe - Math.min(64 / f, elHoehe) - (hoehe + 6) / f;
    } else {
      links = elBreite - breite / f;
      oben = -(hoehe + 6) / f;
    }
    leiste.style.left = Math.round(links) + 'px';
    leiste.style.top = Math.round(oben) + 'px';
    leiste.style.right = 'auto';
    leiste.style.bottom = 'auto';
    leiste.classList.add('mmSchLeisteDa');
  }

  function stellen(el, z, x, y, weg) {
    /* Frei gezogen? Dann nur noch das Kommen-und-Gehen bedienen. */
    if (el.dataset.mmFrei === '1') {
      massstab(el, z);
      if (weg) {
        el.dataset.mmWeg = '1';
        /* Sichtbare Oberkante 40 px unter dem Fenster (die sichtbare Flaeche
           liegt um vy gegenueber der Kastenecke versetzt). */
        el.style.setProperty('top',
          (window.innerHeight + 40 - vermessen(el, z).vy) + 'px', 'important');
      } else {
        el.dataset.mmWeg = '0';
        if (el.__mmFreiPos) freiStellen(el, z, el.__mmFreiPos[0], el.__mmFreiPos[1]);
      }
      return;
    }
    var g = grundwerte(el, z);
    var f = massstab(el, z);
    /* Nach rechts ziehen heisst: Abstand zur rechten Kante wird kleiner. */
    var seite = g.seite + (z.ecke === 'rechts' ? -x : x);
    var unten = g.unten - y;
    /* 25.08.2026: Auf Produktseiten grundsaetzlich hoeher stehen - dort liegen
       unten Kaufknopf, Abo-Auswahl und Upsell. */
    if (PRODUKTSEITE) unten += HOCH_AUF_PRODUKT;
    /* Grundhoehe je Schweber - der KI-Avatar steht generell hoeher. */
    if (z.hoch) unten += z.hoch;
    /* Mindestabstand zur Vorschauleiste. Seit 17.09.2026 (`scale` statt
       `zoom`) sind Kantenabstaende echte Pixel - keine Umrechnung mehr. */
    unten = Math.max(unten, freierBoden());
    /* 23.08.2026, Mert: "es soll nicht staendig da sein, manchmal soll es
       verschwinden und wieder auftauchen, damit es nicht staendig nervt".
       Der alte relative Abzug liess die hoch gesetzte KI teilweise sichtbar.
       Der Weg-Zustand liegt jetzt sicher komplett unterhalb des Fensters. */
    var zielUnten = weg ? -((el.offsetHeight || 60) * f + 24) : unten;
    if (!weg && el.dataset.mmAusweich === '1') zielUnten += AUSWEICH_PX;
    el.dataset.mmWeg = weg ? '1' : '0';
    el.style.setProperty(z.ecke === 'rechts' ? 'right' : 'left', seite + 'px', 'important');
    el.dataset.mmUnten = unten;     /* Grundwert, auf dem das Ausweichen aufbaut */
    el.style.setProperty('transition', 'none', 'important');
    el.style.setProperty('bottom', zielUnten + 'px', 'important');
    if (!weg) imBildHalten(el, z);
    leisteStellen(el, z);
    window.requestAnimationFrame(function () {
      if (!weg) imBildHalten(el, z);
      leisteStellen(el, z);
    });
  }

  /* 25.08.2026 ZWEITE KORREKTUR - Mert: "immernoch versetzt".
     Die erste Fassung hat den Halter per `transform: translateX()` zur Seite
     geschoben. Das war der Fehler, und er stand als Merkposten schon in dieser
     Datei (23.08., Zeile 114): an `transform` haengen die Einblend-Animationen
     der Apps, und eine laufende Animation schlaegt jede Inline-Angabe.
     Zweiter, schlimmerer Nebeneffekt: ein `transform` auf dem Halter macht ihn
     zum Bezugsrahmen fuer `position:fixed`-Kinder. Der Avatar von JotForm ist
     genau so ein Kind - er blieb stehen, waehrend die Bedienleiste mitwanderte.
     Genau das hat Mert als "versetzt" gesehen.
     Jetzt wird ausschliesslich ueber den Kantenabstand ausgewichen - dieselbe
     Technik, mit der die Datei ohnehin schon schiebt. Kein transform, keine
     Deckkraft. */
  /* 25.08.2026 DRITTE KORREKTUR - Mert: "was soll dass man kann es kaum lesen"
     (Titel lief links aus dem Bild) und "handy version fehler".
     Die zweite Fassung wich ZUR SEITE aus: `right` wurde negativ, der Knopf
     stand damit ausserhalb des Fensters. Genau das erzeugt eine waagerechte
     Bildlaufleiste - und auf dem Handy verschiebt sich dadurch die ganze Seite,
     Ueberschrift und Preis rutschen aus dem Bild.
     Jetzt wird nach OBEN ausgewichen. Das kann seitlich nichts verschieben,
     der Knopf bleibt vollstaendig im Bild und weiter bedienbar. Er baut auf dem
     Grundwert auf, den `stellen()` zuletzt gesetzt hat - so ueberschreiben sich
     die beiden nicht mehr gegenseitig. */
  var AUSWEICH_PX = 150;      /* so weit nach oben, wenn der Weg belegt ist */

  function ueberlappt(el, z) {
    /* 17.09.2026: nur die sichtbare Flaeche zaehlt - der fensterbreite
       KI-Halter "ueberlappte" sonst jeden Kaufbereich. */
    var r = kernRect(el, z) || el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    /* Ist der Halter bereits ausgewichen, pruefen wir weiterhin seine
       projizierte Grundposition. Sonst wechselt der Test alle 700 ms zwischen
       "frei" und "belegt" und der Knopf pendelt sichtbar auf und ab. */
    if (el.dataset.mmAusweich === '1') {
      var versatz = AUSWEICH_PX;   /* echte Pixel seit 17.09.2026 */
      r = { left: r.left, right: r.right,
            top: r.top + versatz, bottom: r.bottom + versatz,
            width: r.width, height: r.height };
    }
    var bereiche = document.querySelectorAll(HEILIG);
    for (var i = 0; i < bereiche.length; i++) {
      var b = bereiche[i].getBoundingClientRect();
      if (!b.width || !b.height) continue;
      if (b.bottom < 0 || b.top > window.innerHeight) continue;   /* nicht im Bild */
      if (r.left < b.right && r.right > b.left &&
          r.top < b.bottom && r.bottom > b.top) return true;
    }
    return false;
  }

  function freiHalten(el, z) {
    if (el.dataset.mmWeg === '1') return;      /* gerade ausgeblendet */
    if (el.dataset.mmFrei === '1') return;    /* frei gezogen - nicht mehr ausweichen */
    var soll = ueberlappt(el, z);
    if (el.dataset.mmAusweich === (soll ? '1' : '0')) return;
    el.dataset.mmAusweich = soll ? '1' : '0';
    var grund = parseFloat(el.dataset.mmUnten);
    if (isNaN(grund)) return;
    el.style.setProperty('bottom',
      (soll ? grund + AUSWEICH_PX : grund) + 'px', 'important');
    imBildHalten(el, z);
    leisteStellen(el, z);
  }

  /* 25.08.2026 NACHGEBESSERT (Mert: "problem das ist verrutscht, fehler
     beheben" - der Avatar lag ueber der 2er-Set-Karte). Die erste Fassung hat
     nur beim Scrollen geprueft. Die Upsell-Karten kommen aber von Apps und
     werden Sekunden nach dem Laden erst eingesetzt - zu diesem Zeitpunkt hatte
     niemand gescrollt, also blieb der Knopf stehen, wo er war.
     Jetzt wird zusaetzlich in den ersten 15 Sekunden regelmaessig nachgesehen
     und auf jede Veraenderung im Seiteninhalt reagiert. Danach reichen Scrollen
     und Groessenaenderung. */
  function stellungWache(el, z) {
    if (!PRODUKTSEITE) return;
    var laeuft = false;
    function pruefen() {
      laeuft = false;
      if (el.dataset.mmWeg === '1') return;   /* gerade ausgeblendet */
      if (el.dataset.mmFrei === '1') return;  /* frei gezogen: beim Scrollen nichts tun */
      freiHalten(el, z);
    }
    function anstossen() {
      if (laeuft) return;
      laeuft = true;
      window.requestAnimationFrame(pruefen);
    }

    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });

    /* Nachziehen, solange die Apps noch bauen. */
    var takt = window.setInterval(anstossen, 700);
    window.setTimeout(function () { window.clearInterval(takt); }, 15000);

    if (window.MutationObserver) {
      var w = new MutationObserver(anstossen);
      w.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { w.disconnect(); }, 15000);
    }
    anstossen();
  }

  function ausstatten(z) {
    var el = document.querySelector(z.wahl);
    if (!el || el.dataset.mmSch) return false;
    el.dataset.mmSch = '1';

    if (lies(z.name + ':zu') === '1') {
      el.style.setProperty('display', 'none', 'important');
      return true;
    }

    el.classList.add('mmSchHalter');
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    uebersetzerSperre(el);

    var x = 0, y = 0;
    var gemerkt = (lies(z.name + ':pos') || '').split(',');
    if (gemerkt.length === 2) { x = parseFloat(gemerkt[0]) || 0; y = parseFloat(gemerkt[1]) || 0; }
    var frei = (lies(z.name + ':frei') || '').split(',');
    var freiStart = (frei.length === 2 && !isNaN(parseFloat(frei[0])))
      ? [parseFloat(frei[0]), parseFloat(frei[1])] : null;

    var leiste = document.createElement('div');
    leiste.className = 'mmSchLeiste ' + z.ecke;
    leiste.setAttribute('data-mm-schwebend', z.name);
    leiste.innerHTML =
      '<button type="button" class="mmSchKnopf mmSchGriff" aria-label="Verschieben">' + GRIFF + '</button>' +
      '<button type="button" class="mmSchKnopf mmSchZu" aria-label="Ausblenden">' + KREUZ + '</button>';
    uebersetzerSperre(leiste);
    leiste.style.setProperty('transform', 'scale(' + (1 / faktor(z, el)) + ')', 'important');
    leiste.style.setProperty('transform-origin', 'top left', 'important');
    /* Im App-Teilbaum bleiben; `overflow:visible` und die inverse Skalierung
       halten die Leiste trotzdem vollstaendig und in echter 24-px-Groesse. */
    el.appendChild(leiste);
    el.__mmLeiste = leiste;

    if (freiStart) {
      /* Der Nutzer hatte den Baustein in dieser Sitzung schon frei gesetzt. */
      el.__mmFreiPos = freiStellen(el, z, freiStart[0], freiStart[1]);
      leisteStellen(el, z);
    } else {
      stellen(el, z, x, y);
    }
    stellungWache(el, z);

    function nachziehen() {
      if (!el.isConnected) {
        if (leiste.isConnected) leiste.remove();
        return;
      }
      /* Smile wechselt zwischen rundem Knopf und Pille, wenn das Fenster seine
         Breite aendert - dann gilt ein anderer Faktor. */
      massstab(el, z);
      if (el.dataset.mmFrei === '1') {
        /* Nur dafuer sorgen, dass die frei gewaehlte Stelle im Bild bleibt. */
        if (el.__mmFreiPos) el.__mmFreiPos = freiStellen(el, z, el.__mmFreiPos[0], el.__mmFreiPos[1]);
        leisteStellen(el, z);
        return;
      }
      imBildHalten(el, z);
      leisteStellen(el, z);
    }
    [40, 120, 300, 700, 1400, 2600, 4200].forEach(function (ms) {
      window.setTimeout(nachziehen, ms);
    });
    window.addEventListener('resize', nachziehen, { passive: true });
    /* KEIN Scroll-Listener mehr: Die Bedienleiste sitzt im Halter und wandert
       von allein mit. Der frueher hier haengende Aufruf hat bei jedem Scroll
       das Layout neu vermessen und geschrieben - genau das hat geruckelt. */
    if (window.ResizeObserver) {
      var groessenWache = new ResizeObserver(function () {
        window.requestAnimationFrame(nachziehen);
      });
      groessenWache.observe(el);
    }

    leiste.querySelector('.mmSchZu').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      el.style.setProperty('display', 'none', 'important');
      if (typeof groessenWache !== 'undefined' && groessenWache) groessenWache.disconnect();
      leiste.remove();
      merke(z.name + ':zu', '1');
    });

    var griff = leiste.querySelector('.mmSchGriff');
    var zieht = false, startX = 0, startY = 0, ausX = 0, ausY = 0;

    var freiX = 0, freiY = 0, masse = null;

    function ziehStart(e) {
      zieht = true;
      startX = e.clientX; startY = e.clientY;
      /* Einmal messen: echte Lage und Groesse am Bildschirm. Danach wird waehrend
         der ganzen Bewegung NUR noch geschrieben, nie mehr gelesen. */
      var m = vermessen(el, z);
      freiX = m.s.left; freiY = m.s.top;
      masse = [m.b, m.h, m.vx, m.vy];
      try { e.target.setPointerCapture(e.pointerId); } catch (nix) {}
      e.preventDefault();
    }
    function ziehZug(e) {
      if (!zieht) return;
      /* Direkt schreiben, ohne Umweg ueber requestAnimationFrame: pointermove
         kommt ohnehin im Takt des Bildschirms, und ein einzelnes style-Schreiben
         ist billig. Der Umweg kostete ein Bild Verzoegerung und blieb in einem
         Hintergrund-Tab ganz aus. */
      el.__mmFreiPos = freiStellen(el, z,
        freiX + (e.clientX - startX), freiY + (e.clientY - startY), masse);
    }
    function loslassen() {
      if (!zieht) return;
      zieht = false;
      if (el.__mmFreiPos) {
        /* Erst jetzt einmal aufraeumen: in den sichtbaren Bereich klemmen,
           Bedienleiste nachziehen, Stelle fuer diese Sitzung merken. */
        el.__mmFreiPos = freiStellen(el, z, el.__mmFreiPos[0], el.__mmFreiPos[1]);
        merke(z.name + ':frei', el.__mmFreiPos[0] + ',' + el.__mmFreiPos[1]);
        leisteStellen(el, z);
      }
      masse = null;
    }
    griff.addEventListener('pointerdown', ziehStart);
    griff.addEventListener('pointermove', ziehZug);
    griff.addEventListener('pointerup', loslassen);
    griff.addEventListener('pointercancel', loslassen);

    /* --- Der ganze Baustein ist die Ziehflaeche ------------------------------
       04.09.2026, Mert: "nicht nur symbole anfassen und verschieben sondern der
       ganze kreis muss bewegbar sein sowie auch punkte sammeln unten rechts".

       Warum eine eigene Deckschicht noetig ist: Beide Apps liefern ihren Inhalt
       in einem fremden iframe. Aus einem fremden iframe kommt KEIN Mausereignis
       nach draussen - am Baustein selbst laesst sich also nichts abgreifen.
       Deshalb liegt eine unsichtbare Flaeche darueber.

       Damit der Chat und "Punkte sammeln" weiter anklickbar bleiben, gilt:
       kurzes Tippen ohne Bewegung = Klick, er wird an das darunterliegende
       Element weitergereicht. Erst ab 6 px Bewegung wird daraus ein Ziehen und
       der Klick unterdrueckt. Bei Smile liegt der Knopf in einem fremden iframe,
       das sich nicht fernsteuern laesst - dort bleibt die Mitte des Kastens
       ausgespart und nur der Rand zieht. */
    var deck = document.createElement('div');
    deck.className = 'mmSchDeck';
    deck.setAttribute('data-mm-schwebend', z.name + '-deck');
    uebersetzerSperre(deck);
    if (z.mitte) deck.classList.add('mmSchDeckRand');
    el.appendChild(deck);
    el.__mmDeck = deck;
    deckStellen(el, z);

    var tippX = 0, tippY = 0, bewegt = false;
    deck.addEventListener('pointerdown', function (e) {
      tippX = e.clientX; tippY = e.clientY; bewegt = false;
      ziehStart(e);
    });
    deck.addEventListener('pointermove', function (e) {
      if (!zieht) return;
      if (!bewegt &&
          (Math.abs(e.clientX - tippX) > 6 || Math.abs(e.clientY - tippY) > 6)) bewegt = true;
      if (bewegt) ziehZug(e);
    });
    function deckLos(e) {
      if (!zieht) return;
      var warBewegung = bewegt;
      loslassen();
      if (warBewegung) return;
      /* Kein Ziehen, sondern ein Tippen: den Klick weitergeben. */
      deck.style.pointerEvents = 'none';
      var ziel = document.elementFromPoint(e.clientX, e.clientY);
      if (ziel && ziel !== deck && typeof ziel.click === 'function' &&
          ziel.tagName !== 'IFRAME') {
        ziel.click();
      }
      window.setTimeout(function () { deck.style.pointerEvents = ''; }, 350);
    }
    deck.addEventListener('pointerup', deckLos);
    deck.addEventListener('pointercancel', loslassen);

    /* --- Kommt und geht -----------------------------------------------------
       23.08.2026, Mert: "beides kann man bewegen und es soll nicht staendig da
       sein, manchmal soll es verschwinden und wieder auftauchen, damit es nicht
       staendig nervt".
       Also: SICHTBAR_MS sichtbar, dann WEG_MS unten aus dem Bild geschoben.
       Wer mit der Maus darauf geht oder es anfasst, haelt es fest - erst wenn
       er wieder weg ist, laeuft die Uhr weiter. Im Hintergrund laeuft nichts
       (feste Regel vom 23.08.2026). */
    var weg = false, uhr = null, festgehalten = false;

    function plane(ms) {
      window.clearTimeout(uhr);
      uhr = window.setTimeout(function () {
        if (document.hidden || festgehalten || zieht) { plane(4000); return; }
        weg = !weg;
        stellen(el, z, x, y, weg);
        plane(weg ? WEG_MS : SICHTBAR_MS);
      }, ms);
    }

    function festhalten() {
      festgehalten = true;
      if (weg) { weg = false; stellen(el, z, x, y, false); }
    }
    function freigeben() {
      festgehalten = false;
      plane(SICHTBAR_MS);
    }
    el.addEventListener('pointerenter', festhalten);
    el.addEventListener('pointerleave', freigeben);
    deck.addEventListener('pointerenter', festhalten);
    deck.addEventListener('pointerleave', freigeben);
    leiste.addEventListener('pointerenter', festhalten);
    leiste.addEventListener('pointerleave', freigeben);
    plane(SICHTBAR_MS);

    return true;
  }

  /* Beide Bausteine kommen von fremden Skripten und erscheinen verzoegert.
     GEMESSEN am 23.08.2026: der KI-Berater ist nach rund zwei Sekunden da,
     "Punkte sammeln" von Smile kann laenger als eine halbe Minute brauchen -
     ein Zaehler, der nach 28 Sekunden aufgibt, verpasst ihn. Deshalb sieht
     jetzt ein Beobachter am Dokument zu und gibt erst Ruhe, wenn beide
     versorgt sind. */
  function fehlen() {
    return ZIEL.some(function (z) {
      var el = document.querySelector(z.wahl);
      return !el || !el.dataset.mmSch;
    });
  }

  function wache() {
    stil();
    ZIEL.forEach(ausstatten);
    if (!fehlen()) return;

    var beo = new MutationObserver(function () {
      ZIEL.forEach(function (z) {
        var el = document.querySelector(z.wahl);
        if (el && !el.dataset.mmSch) ausstatten(z);
      });
      if (!fehlen()) beo.disconnect();
    });
    beo.observe(document.body || document.documentElement,
                { childList: true, subtree: true });

    /* Der Beobachter am ganzen Dokument ist teuer, deshalb laeuft er nur die
       erste halbe Minute. Danach uebernimmt ein ruhiger Zwei-Sekunden-Takt:
       "Punkte sammeln" von Smile ist bei einer Messung auch nach 34 Sekunden
       noch nicht dagewesen, kam bei einer anderen aber sehr wohl - die App
       laedt sich offenbar traege nach. Nach fuenf Minuten ist Schluss. */
    window.setTimeout(function () {
      beo.disconnect();
      if (!fehlen()) return;
      var n = 0;
      var t = window.setInterval(function () {
        n++;
        ZIEL.forEach(function (z) {
          var el = document.querySelector(z.wahl);
          if (el && !el.dataset.mmSch) ausstatten(z);
        });
        if (!fehlen() || n > 135) window.clearInterval(t);
      }, 2000);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wache);
  } else {
    wache();
  }
})();
